(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/maintenance-view/assets/javascripts/maintenance-view.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/maintenance-view/assets/javascripts/maintenance-view.js');
"use strict";

const _svs$oddset_kambi$dat = svs.oddset_kambi.data.maintenanceConfig,
  header = _svs$oddset_kambi$dat.header,
  cmsDefinedMaintenanceText = _svs$oddset_kambi$dat.body;
const MaintenanceView = _ref => {
  let maintenanceText = _ref.maintenanceText;
  return React.createElement("div", {
    className: "oddset-maintenance-view"
  }, React.createElement("div", {
    className: "oddset-maintenance-view__left"
  }), React.createElement("div", {
    className: "oddset-maintenance-view__right"
  }, React.createElement("h2", null, header), React.createElement("h4", null, maintenanceText !== null && maintenanceText !== void 0 ? maintenanceText : cmsDefinedMaintenanceText), React.createElement("p", null, "Spel fr\xE5n Svenska Spel & Casino AB")));
};
setGlobal('svs.oddset_kambi.components.maintenance_view.MaintenanceView', MaintenanceView);

 })(window);